import { Box } from "@sidelinesports/fan-design-system";
import { clsx } from "clsx";
import styles from "./FullscreenFixedLayout.module.css";

/**
 * This is similar to the `FullscreenLayout` component, but it allows for
 * a fixed header and footer.
 */
export const FullscreenFixedLayout = ({
  children,
  header,
  footer,
  className,
}: {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}) => {
  return (
    <Box bg="primary" className={clsx(styles.layout, className)}>
      {header && <div>{header}</div>}
      <div className={styles.content}>{children}</div>
      {footer && <div>{footer}</div>}
    </Box>
  );
};
